export default __webpack_public_path__ + "static/media/README.9ec66c0f.md";